<template>
	<v-container v-if="!isChecking">
		<v-row class="mb-6">
		<v-col cols="12">
			<div class="stepper-container">
				<div
					v-for="step in totalSteps"
					:key="step"
					class="step-item"
					:class="{ active: currentStep === step }"
					@click="currentStep = step"
				>
					<div class="step-circle">{{ step }}</div>
					<div class="step-label">
						<span v-if="step === 1">Business Activity</span>
						<span v-if="step === 2">Water Usage</span>
						<span v-if="step === 3">Health & Safety</span>
						<span v-if="step === 4">Diversity & Equality</span>
					</div>
				</div>
			</div>
		</v-col>
		</v-row>

		<VsmeBusiness
			v-if="currentStep === 1"
			:initial-data="savedData.business"
			:is-edit-mode="isEditMode"
			@saved="onBusinessSaved"
		/>
		<VsmeWater
			v-if="currentStep === 2"
			:initial-data="savedData.water"
			:is-edit-mode="isEditMode"
			@saved="onWaterSaved"
			@back="prevStep"
		/>
		<VsmeHealth
			v-if="currentStep === 3"
			:initial-data="savedData.health"
			:is-edit-mode="isEditMode"
			@saved="onHealthSaved"
			@back="prevStep"
		/>
		<VsmeDiversity
			v-if="currentStep === 4"
			:initial-data="savedData.diversity"
			:is-edit-mode="isEditMode"
			@saved="onDiversitySaved"
			@back="prevStep"
		/>
	</v-container>
</template>

<script>
import CsrAPI from "../api/csr/csr"
import VsmeBusiness from "./VsmeBusiness.vue"
import VsmeWater from "./VsmeWater.vue"
import VsmeHealth from "./VsmeHealth.vue"
import VsmeDiversity from "./VsmeDiversity.vue"

export default {
	components: { VsmeBusiness, VsmeWater, VsmeHealth, VsmeDiversity },

	data() {
		return {
			isChecking: true,
			currentStep: 1,
			totalSteps: 4,
			isEditMode: false,
			savedData: {
				business:  null,
				water:     null,
				health:    null,
				diversity: null,
			},
		}
	},

	mounted() {
		this.init()
	},

	methods: {
		goToStep(step) {
			this.currentStep = step
		},
		nextStep() {
			if (this.currentStep < this.totalSteps) this.currentStep++
		},
		prevStep() {
			if (this.currentStep > 1) this.currentStep--
		},

		async init() {
			this.isEditMode = this.$route.params.editMode === true || this.$route.params.editMode === "true"
			const startStep = parseInt(this.$route.params.startStep) || 1

			try {
				const [businessRes, diversityRes] = await Promise.allSettled([
					CsrAPI.getVsmeBusinessActivity(),
					CsrAPI.getVsmeDiversity(),
				])

				if (businessRes.status === "fulfilled" && businessRes.value) {
					this.savedData.business = businessRes.value
				}
				if (diversityRes.status === "fulfilled" && diversityRes.value) {
					this.savedData.diversity = diversityRes.value
				}

				// If data exists and not editing, redirect to results
				if (!this.isEditMode && this.savedData.diversity) {
					const d = this.savedData.diversity

					if (
						d.Total_Employees ||
						d.Gender_Distribution ||
						d.Age_Distribution ||
						d.DI_Policy
					) {
						this.currentStep = 4
					}
				}

				this.currentStep = (startStep >= 1 && startStep <= this.totalSteps) ? startStep : 1

			} catch (error) {
				console.error("Init error:", error)
			} finally {
				this.isChecking = false
			}
		},

		onBusinessSaved() {
			window.location.reload()
		},
		onWaterSaved() {
			window.location.reload()
		},
		onHealthSaved() {
			window.location.reload()
		},
		onDiversitySaved() {
			window.location.reload()
		},
	},
}
</script>

<style scoped>
.stepper-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}

.step-item {
	text-align: center;
	cursor: pointer;
	flex: 1;
	position: relative;
}

.step-circle {
	width: 35px;
	height: 35px;
	border-radius: 50%;
	background: #ddd;
	color: #555;
	margin: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
}

.step-item.active .step-circle {
	background: #1e7c83;
	color: white;
}

.step-item.active .step-label {
	color: #1e7c83;
	font-weight: bold;
}
</style>